export default __webpack_public_path__ + "static/media/prbicon_eForms.3088d427.svg";